import "./OurTopPicks.css";
import { useNavigate } from "react-router-dom";
import CustomButton from "src/components/common/CustomButton";
import { useIsMobile } from "src/hooks/useIsMobile";
import { BREAKPOINTS } from "src/utils/viewport";

const OurTopPicks = ({ data }: { data: any }) => {
  const isMobile = useIsMobile(BREAKPOINTS.lg);
  const navigate = useNavigate();

  const getCategoryPath = (category: any) => {
    if (category?.title?.toLowerCase?.() === "apparel") {
      return "/blanks";
    }
    return category?.path;
  };

  const handleCardClick = (link: string) => {
    navigate(link);
    window.scrollTo(0, 0);
  };

  return (
    <section className="top-categories">
      <h2 className="top-categories-title">{data?.header}</h2>
      <div className="top-secondry">
        <div className="category-cards">
          {data?.products.map((category: any, index: number) => (
            <CustomButton
              className="category-card"
              key={index}
              onClick={() => handleCardClick(getCategoryPath(category))}
              style={{ cursor: "pointer" }}
              link={getCategoryPath(category)}
            >
              <img src={category.image} alt={category.title} />
              <div className="line"></div>
              <p className="category-title">{category.title}</p>
              {!isMobile && (
                <div className="category-description">{category.subtitle}</div>
              )}
            </CustomButton>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTopPicks;
